import React from 'react';
import '../App.scss';

export default function(){
    return(
        <div className="footer">
            تم صنع هذا التطبيق من طرف <a href="https://github.com/medlabs">MedLabs</a> و هدفه الإفادة
        </div>
    )
}